import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = [
  {
    label: 'S.N',
    value: 'S.N',
  },

  {
    label: 'Date',
    value: 'actualSupplyDate',
  },
  {
    label: 'Batch id',
    value: 'materialInwardBatchId',
  },
  {
    label: 'Material Hub',
    value: 'pickupPointName',
  },
  /*  {
    label: 'Franchise',
    value: '-',
  },
  {
    label: 'Address',
    value: 'pickup_address',
  }, */
  {
    label: 'Category',
    value: 'categoryName',
  },
  /* {
    label: 'Icon',
    value: 'categoryIcon',
  }, */
  {
    label: 'Item',
    value: 'pickup_quantity_item',
  },
  {
    label: 'Quantity',
    value: 'pickup_quantity',
  },
  {
    label: 'Customer',
    // value: 'pickupInfo[centreName]',
    value: 'converterName',
  } /* 
  {
    label: 'Delivered On',
    value: 'completedAt',
  },
  {
    label: 'Status',
    value: 'status',
  }, */,

  // {
  //   label: 'certificate_view',
  // },
  {
    label: 'Status',
    value: 'status',
  },
  {
    label: 'coc',
    value: 'cocpopup',
  },
  // {
  //   action: ['edit', 'view'],
  // },
  {
    action: [''],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
